module.exports = __webpack_public_path__ + "img/av-spin.c697eca8.svg";